import React from 'react'
import { Portal } from 'react-portal'
import { ShareModalEl } from './Elements'
import Button from '../Buttons/Button'
import { H6, Text } from '../../Styles/typography.js'
import { notify } from '../../Helpers/Notifications'
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share'

function ShareModal({
  close,
  url,
  courseName,
  teacherName,
  courseType = 'Masterclass',
}) {
  const shareText =
    courseType === 'Masterclass'
      ? `I'm attending a ${courseType} on ${courseName} by ${teacherName} on @LivDemy! If you want to attend this with me click here:`
      : `I'm attending a ${courseType} - ${courseName} by ${teacherName} on @LivDemy! If you want to attend this with me click here:`
  return (
    <Portal>
      <ShareModalEl onClick={() => close()}>
        <div className='modalContent' onClick={(e) => e.stopPropagation()}>
          <H6 className='header'>
            <b>Share</b> <span onClick={() => close()}>x</span>
          </H6>
          <div className='social'>
            <div className='share-btn'>
              <FacebookShareButton
                quote={`${shareText} ${url}`}
                url={url}
                hashtag={`#livdemy #${courseType.toLowerCase()}`}
              >
                <div>
                  <FacebookIcon size={32} round />
                  <p>Facebook</p>
                </div>
              </FacebookShareButton>
            </div>
            <div className='share-btn'>
              <LinkedinShareButton
                title={courseName}
                summary={`${shareText} ${url}`}
                source={url}
                url={url}
              >
                <div>
                  <LinkedinIcon size={32} round />
                  <p>LinkedIn</p>
                </div>
              </LinkedinShareButton>
            </div>
            <div className='share-btn'>
              <TwitterShareButton
                title={shareText}
                hashtags={['livdemy', courseType.toLowerCase()]}
                url={url}
              >
                <div>
                  <TwitterIcon size={32} round />
                  <p>Twitter</p>
                </div>
              </TwitterShareButton>
            </div>
            <div className='share-btn'>
              <WhatsappShareButton title={shareText} url={url}>
                <div>
                  <WhatsappIcon size={32} round />
                  <p>Whatsapp</p>
                </div>
              </WhatsappShareButton>
            </div>
          </div>
          <div className='copy-url'>
            <Text className='heading'>Copy URL to share</Text>
            <div className='url'>
              <p>{url}</p>
              <Button
                name='Copy'
                onClick={async () => {
                  await navigator.clipboard.writeText(`${url}`)
                  notify('success', `Successfully copied the url to clipboard`)
                }}
              ></Button>
            </div>
          </div>
        </div>
      </ShareModalEl>
    </Portal>
  )
}

export default ShareModal
